import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {Observable, of, ReplaySubject} from 'rxjs';
import {catchError, share, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {ToastService} from '../../../../shared/src/lib/services/toast.service';

export interface UserConfig {
  id: number;
  name: string;
  permissions: string[];
  is_superuser: boolean;
  groups: string[];
  ptt?: {
    id: number;
    name: string;
    group: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {
  config: ReplaySubject<UserConfig> = new ReplaySubject<UserConfig>();
  private current_config: UserConfig;
  constructor(public http: HttpClient, private router: Router, private toastService: ToastService) {
    this.config.pipe(share()).subscribe(config => this.current_config = config);
    this.loadConfig();
  }

  loadConfig(): Observable<any> {
    return this.http.get<UserConfig>(`${environment.baseUrl}/current_user/`).pipe(
      tap(config => this.config.next(config)),
      catchError(error => {
        this.toastService.error('Unauthorized');
        return this.router.navigate(['login'])
      })
    );
  }

  checkGroups(groups: string[]) {
    if (this.current_config.is_superuser) {
      return true;
    }
    for (const group of groups) {
      if (this.current_config.groups.includes(group)) {
        return true;
      }
    }
    return false;
  }

  checkPermissions(permission: string) {
    return this.current_config.is_superuser ? this.current_config.is_superuser : this.current_config.permissions.includes(permission);
  }

}

export const canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(UserConfigService).loadConfig();
}
